import { render, staticRenderFns } from "./OptionButtons.vue?vue&type=template&id=2758fae6&"
import script from "./OptionButtons.vue?vue&type=script&lang=js&"
export * from "./OptionButtons.vue?vue&type=script&lang=js&"
import style0 from "./OptionButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports